import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Plugin from '@jbrowse/core/Plugin';
import { isAbstractMenuManager } from '@jbrowse/core/util';
// icons
import LineStyleIcon from '@mui/icons-material/LineStyle';
// locals
import { BaseLinearDisplay, BaseLinearDisplayComponent, BlockMsg, baseLinearDisplayConfigSchema } from './BaseLinearDisplay';
import LinearBareDisplayF, { configSchemaFactory as linearBareDisplayConfigSchemaFactory } from './LinearBareDisplay';
import LinearGenomeViewF, { RefNameAutocomplete, SearchBox, ZoomControls, LinearGenomeView } from './LinearGenomeView';
import { renderToSvg, totalHeight, SVGTracks, SVGRuler } from './LinearGenomeView/svgcomponents/SVGLinearGenomeView';
import LinearBasicDisplayF, { configSchema as linearBasicDisplayConfigSchemaFactory, modelFactory as linearBasicDisplayModelFactory } from './LinearBasicDisplay';
import FeatureTrackF from './FeatureTrack';
import BasicTrackF from './BasicTrack';
import LaunchLinearGenomeViewF from './LaunchLinearGenomeView';
var LinearGenomeViewPlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(LinearGenomeViewPlugin, _Plugin);
  function LinearGenomeViewPlugin() {
    var _this;
    _classCallCheck(this, LinearGenomeViewPlugin);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(LinearGenomeViewPlugin).apply(this, arguments));
    _this.name = 'LinearGenomeViewPlugin';
    _this.exports = {
      BaseLinearDisplayComponent: BaseLinearDisplayComponent,
      BaseLinearDisplay: BaseLinearDisplay,
      baseLinearDisplayConfigSchema: baseLinearDisplayConfigSchema,
      SearchBox: SearchBox,
      ZoomControls: ZoomControls,
      LinearGenomeView: LinearGenomeView
    };
    return _this;
  }
  _createClass(LinearGenomeViewPlugin, [{
    key: "install",
    value: function install(pluginManager) {
      FeatureTrackF(pluginManager);
      BasicTrackF(pluginManager);
      LinearBasicDisplayF(pluginManager);
      LinearGenomeViewF(pluginManager);
      LinearBareDisplayF(pluginManager);
      LaunchLinearGenomeViewF(pluginManager);
    }
  }, {
    key: "configure",
    value: function configure(pluginManager) {
      if (isAbstractMenuManager(pluginManager.rootModel)) {
        pluginManager.rootModel.appendToSubMenu(['Add'], {
          label: 'Linear genome view',
          icon: LineStyleIcon,
          onClick: function onClick(session) {
            session.addView('LinearGenomeView', {});
          }
        });
      }
    }
  }]);
  return LinearGenomeViewPlugin;
}(Plugin);
export { LinearGenomeViewPlugin as default };
export { baseLinearDisplayConfigSchema, linearBareDisplayConfigSchemaFactory, linearBasicDisplayConfigSchemaFactory, linearBasicDisplayModelFactory, renderToSvg, totalHeight, SVGTracks, SVGRuler, BaseLinearDisplayComponent, BaseLinearDisplay, RefNameAutocomplete, SearchBox, BlockMsg };